module.exports = __webpack_public_path__ + "static/media/NotoSansJP_medium.d965a068.woff";